export enum CalendarMonthsShortLabelEnum {
  'm1' = 'Jan.',
  'm2' = 'Feb.',
  'm3' = 'Mar.',
  'm4' = 'Apr.',
  'm5' = 'May.',
  'm6' = 'Jun.',
  'm7' = 'Jul.',
  'm8' = 'Aug.',
  'm9' = 'Sep.',
  'm10' = 'Oct.',
  'm11' = 'Nov.',
  'm12' = 'Dec.',
}
